/**
 * @file Internet Explorer Warning.
 */

import React from 'react';

import Alert from './Alert';

const InternetExplorerWarning = () => (
  <Alert type="warning" className="text-center m-0">
    We noticed you are using Internet Explorer, an outdated and considerably
    unsafe browser. For the best Waldo experience, please try{' '}
    <a
      className="alert-link"
      href="https://www.google.com/chrome/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Chrome
    </a>
    ,{' '}
    <a
      className="alert-link"
      href="https://www.mozilla.org/firefox"
      target="_blank"
      rel="noopener noreferrer"
    >
      Firefox
    </a>
    , or{' '}
    <a
      className="alert-link"
      href="https://www.microsoft.com/en-us/windows/microsoft-edge"
      target="_blank"
      rel="noopener noreferrer"
    >
      Microsoft Edge
    </a>
    .
  </Alert>
);

export default InternetExplorerWarning;
